export default __webpack_public_path__ + "static/media/prodDefault.cf9245db.svg";